export default __webpack_public_path__ + "static/media/text-bnb.492f1a36.svg";